import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.Table,
  title: 'Table',
  category: ComponentCategory.General,
};
